module.exports = __webpack_public_path__ + "svg/scorpio.svg?70fc57ac3579037c7d6bb73a6ab00980";